import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import SearchIcon from '@mui/icons-material/Search';
import {
  SearchIconBox,
  SearchIconWrapper,
  SearchInputBase,
  SearchWrapper,
} from './index.style';

const AppSearch = ({
  placeholder,
  align,
  overlap,
  onlyIcon,
  disableFocus,
  iconStyle = {},
  wrapperIconStyle,
  iconPosition,
  ...rest
}) => {

  return (
    <SearchWrapper sx={rest.sx} iconPosition={iconPosition}>
      <SearchIconBox
        align={align}
        className={clsx(
          'searchRoot',
          { 'hs-search': overlap },
          { 'hs-disableFocus': disableFocus },
          { searchIconBox: onlyIcon },
        )}
      >
        <SearchIconWrapper
          className={clsx({
            right: iconPosition === 'right',
          })}
          sx={{ left: iconPosition === 'left' ? '12px' : 'auto', right: iconPosition === 'left' ? 'auto' : '12px' }}
          style={wrapperIconStyle}
        >
          <SearchIcon sx={iconStyle} />
        </SearchIconWrapper>
        <SearchInputBase
          id='search-input'
          placeholder={placeholder || 'Search…'}
          name='input-search-app'
          inputProps={{
            'autocomplete': 'one-time-code',
            'aria-label': 'search',
            'aria-autocomplete': 'none',
            autoComplete: 'off'
          }}
          {...rest}
        />
      </SearchIconBox>
    </SearchWrapper>
  );
};

export default AppSearch;

AppSearch.propTypes = {
  iconPosition: PropTypes.string,
  align: PropTypes.string,
  placeholder: PropTypes.string,
  overlap: PropTypes.bool,
  borderLight: PropTypes.bool,
  className: PropTypes.string,
  onlyIcon: PropTypes.bool,
  disableFocus: PropTypes.bool,
  iconStyle: PropTypes.object,
  wrapperIconStyle: PropTypes.object
};

AppSearch.defaultProps = {
  onlyIcon: false,
  overlap: true,
  iconPosition: 'left',
  align: 'left',
  iconStyle: {
    color: 'grey',
  },
};
